import {
  returnAllTradeDetailsFromGenericParams,
  returnOPLegFormThisTrade,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { ExecutionRequestQuoteLeg } from "@/lib/interfaces and Enums/InterfaceExecutionRequestQuoteLeg";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";

// Returns the OP leg ONLY when its iceberg is an active reduction — i.e. the
// CP is being shown a smaller size than the full notional. Returns null for
// RP, when the leg has no releaseNotionalLeg1, or when releaseNotionalLeg1
// equals notionalLeg1 (iceberg back to 100%). Both the cell renderer (for the
// "*" marker) and the tooltip getter share this gating.
export function getActiveIcebergLegForOP(
  params: any,
  thisTrade: ExecutionStrategy | undefined,
): ExecutionRequestQuoteLeg | null {
  const { isOp, isER, isLeg, isOutright } =
    returnAllTradeDetailsFromGenericParams(params);

  if (!isOp || !thisTrade) return null;

  const leg = returnOPLegFormThisTrade({
    params,
    thisTrade,
    isOp,
    isER,
    isOutright,
    isLeg,
  });

  if (!leg?.releaseNotionalLeg1) return null;
  if (leg.releaseNotionalLeg1 === leg.notionalLeg1) return null;

  return leg;
}
